import React from "react"
import { Drawer } from "@kit/design/drawer"
import { NotificationsList } from "./notifications-list"

export function BulkNotificationsDrawer({ open, onClose, topics }) {
  return (
    <Drawer open={open} onOpenChange={isOpen => !isOpen && onClose()}>
      <Drawer.Content>
        <Drawer.Header>
          <Drawer.Title>Notifications</Drawer.Title>
          <Drawer.Close />
        </Drawer.Header>
        <Drawer.Body>
          <NotificationsList topics={topics} />
        </Drawer.Body>
      </Drawer.Content>
    </Drawer>
  )
}
